import { io } from 'socket.io-client';
import { API_BASE } from '../config/Api_base';

let socket = null;

export function getSocket() {
    // Nếu chưa có socket, tự connect luôn (tránh phụ thuộc thứ tự useEffect)
    if (!socket) {
        return connectSocket();
    }
    return socket;
}

export function connectSocket() {
    // Đã có instance rồi thì dùng lại (dù đang connecting hay connected)
    if (socket) return socket;

    const token = localStorage.getItem('token');
    if (!token) return null;

    socket = io(API_BASE, {
        transports: ['websocket'],
        auth: { token },
        reconnection: true,
        reconnectionAttempts: 10,
        reconnectionDelay: 2000,
    });

    socket.on('connect', () => {
        console.log('[Socket] Connected');
    });

    socket.on('disconnect', () => {
        console.log('[Socket] Disconnected');
    });

    return socket;
}

export function disconnectSocket() {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
}
